export const PRICING_TIER_OPTIONS = [
  { id: 'retail', label: 'Retail' },
  { id: 'wholesale', label: 'Wholesale' },
  { id: 'vip', label: 'VIP' },
];

export function normalizePricingTier(value) {
  const tier = String(value || '').trim().toLowerCase();
  return PRICING_TIER_OPTIONS.some((option) => option.id === tier) ? tier : 'retail';
}

function numericOrNull(value) {
  if (value === '' || value == null) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

export function resolveTierPrice({ retailPrice, wholesalePrice, vipPrice, pricingTier = 'retail' }) {
  const retail = Number(retailPrice || 0);
  const wholesale = numericOrNull(wholesalePrice);
  const vip = numericOrNull(vipPrice);
  const normalizedTier = normalizePricingTier(pricingTier);

  if (normalizedTier === 'wholesale') {
    return wholesale != null && wholesale > 0 ? wholesale : retail;
  }

  if (normalizedTier === 'vip') {
    if (vip != null && vip > 0) return vip;
    if (wholesale != null && wholesale > 0) return wholesale;
    return retail;
  }

  return retail;
}

export function pricingTierLabel(value) {
  return PRICING_TIER_OPTIONS.find((option) => option.id === normalizePricingTier(value))?.label || 'Retail';
}
